import React, {useEffect, useState} from 'react';
import style from "./index.module.scss"
import WrapperContent from "../../components/shared/WrapperContent";
import HeaderContent from "../../components/shared/HeaderContent";
import {Link, useSearchParams} from "react-router-dom";
import PlusIcon from "../../components/shared/icons/PlusIcon";
import ArrowDownIcon from "../../components/shared/icons/ArrowDownIcon";
import DriverItemCard from "../../components/drivers/DriverItemCard";
import ModalConfirm from "../../components/shared/ModalWindow/Confirm";
import {Driver} from '../../services';
import {requestErrorDisplay} from '../../utils';
import {useSelector} from 'react-redux';
import Loading from '../../components/shared/Loading/Loading';
import EmptyContent from '../../components/shared/emptyContent';
import { t } from "i18next";
import { Share } from 'lucide-react';

const DriversPage = () => {
  const { user } = useSelector(state => state);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setLoading] = useState(false)
  const [drivers, setDrivers] = useState([])

  const getContent = () => {
    setLoading(true)
    Driver.getDriversListByExpeditor(user?.companyId)
      .then(res => res.data)
      .then(data => {
        setDrivers(data)
      })
      .catch(e => {
        requestErrorDisplay(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  useEffect(() => {
    getContent()
  }, [])

  return (
    <div className={style.workers_wrapper}>
      <WrapperContent>
        <HeaderContent title={t("drivers.pageTitle")} />
        <Link to={"/drivers/create"} className={style.button}>
          <PlusIcon />
          <span>{t("drivers.addDriverButton")}</span>
        </Link>
        {user?.isCnUser && (
          <Link to={"/drivers/invite"} className={style.button} style={{ marginLeft: "10px" }}>
            <Share size={18} color="#6D7885" />
            <span>{t("driversCreatePage.inviteDriver")}</span>
          </Link>
        )}
        <div className={style.itemsSort}>
          <span>{t("drivers.countLabel", { count: drivers.length })}</span>
          {/* TODO */}
          {/*<div className={style.dropdown}>*/}
          {/*  <div className={style.dropdown_selected}>*/}
          {/*    <span>По алфавиту</span>*/}
          {/*    <ArrowDownIcon />*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
        <DriverItemCard isHead isCnUser={user?.isCnUser} />
        {isLoading && <Loading inBlock />}
        {!isLoading && drivers.map(d => <DriverItemCard key={d.id} item={d} isCnUser={user?.isCnUser} onDriverUpdate={getContent} />)}
        {!isLoading && !drivers.length && <EmptyContent />}

        {searchParams.get("created") === "1" && (
          <ModalConfirm
            onClose={() => setSearchParams({ created: 0 })}
            title={t("drivers.modal.driverAddedTitle")}
            summary={t("drivers.modal.driverAddedSummary")}
          />
        )}
      </WrapperContent>
    </div>
  );
};

export default DriversPage;